"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _actions = require("./actions");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledBottomRow = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  border-top: 2px solid #f4f4f4;\n"])));

var Wrapper = function Wrapper(_ref) {
  var history = _ref.history,
      app = _ref.app;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector = (0, _reactRedux.useSelector)(function (s) {
    return s.betbar;
  }),
      hadBet = _useSelector.hadBet,
      activeBet = _useSelector.activeBet,
      activePickem = _useSelector.activePickem,
      isBetsOpen = _useSelector.isBetsOpen,
      isActivePickemInPlay = _useSelector.isActivePickemInPlay,
      isActivePickemCompleted = _useSelector.isActivePickemCompleted;

  var loggedInUserName = app.loggedInUserName,
      loggedInUserImage = app.loggedInUserImage,
      isShowingMyBet = app.isShowingMyBet;
  var isInPlayOrCompleted = isActivePickemInPlay || isActivePickemCompleted;
  var row = {
    rank: hadBet && (activeBet === null || activeBet === void 0 ? void 0 : activeBet.rank) || "-",
    points: hadBet && (activeBet === null || activeBet === void 0 ? void 0 : activeBet.points) > -1 ? activeBet === null || activeBet === void 0 ? void 0 : activeBet.points : "",
    prize: hadBet && (activeBet === null || activeBet === void 0 ? void 0 : activeBet.prize) || "",
    user: {
      username: loggedInUserName,
      image: loggedInUserImage
    }
  };

  var handleMyBetClicked = function handleMyBetClicked() {
    window.scrollTo(0, 0);
    dispatch((0, _actions.getMyBet)(activeBet, !isShowingMyBet));
    history.push("/leaderboard");
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledBottomRow, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.LeaderboardRowHeader, {
      showLabels: hadBet,
      isPageHeader: true,
      isPreMatchLeaderboard: !isInPlayOrCompleted,
      row: row,
      onRowClicked: handleMyBetClicked
    })
  });
};

var _default = Wrapper;
exports.default = _default;